import { deserialize } from 'cerialize'
import { Id } from 'Src/types/aliases'

export class LandingModel {
	@deserialize public id: Id
	@deserialize public name: string
	@deserialize public link: string
	@deserialize public with_qr_code: boolean
	@deserialize public status: string
	@deserialize public sticker: File | null
	@deserialize public banner: File | null
	@deserialize public erid?: string
}
